import Component from 'gia/Component'
import _each from 'lodash.foreach'


class Popup extends Component {

  constructor(element) {

    super(element)

  

    this.element = element

    this.index = 0
    this.current = 0


    this.ref = {
      
      newsletter: null

    }

  }

  mount() {

   
       $(this.ref.newsletter).on('click', (e)=>{
            e.preventDefault()

            document.body.classList.add('has-form')
            document.body.classList.remove('has-popup')
       })

       $('[data-button="close"]').on('click', (e) => {
           e.preventDefault()

           document.body.classList.remove('has-form')
       })
       $('[data-button="exit"]').on('click', (e) => {
        e.preventDefault()

        document.body.classList.remove('has-popup')
    })

  }

  




  resize() {

  }

  unmount() {

    // this.observer.disconnect()


   

  }


}

module.exports = Popup